export default __webpack_public_path__ + "static/media/iron-bridge.0ee70453.png";